/**
 * @generated SignedSource<<737f7130673fbd28b82427a863b28b41>>
 * @relayHash 0cfd05b06ffa73a3bef6a663a903c9ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b91bfb71db04c813d336d713b9bf262ac87f3f8ffca237eb62f8896d08344eca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_DesignPanelQuery } from './ui_DesignPanelQuery.graphql';

const node: PreloadableConcreteRequest<ui_DesignPanelQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b91bfb71db04c813d336d713b9bf262ac87f3f8ffca237eb62f8896d08344eca",
    "metadata": {},
    "name": "ui_DesignPanelQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
